export class BeforeunloadService {

    public static readonly $inject: string[] = ["$rootScope"];

    constructor(private $rootScope: angular.IScope) {
        this.$rootScope.$on("$locationChangeStart", () => {
            window.dispatchEvent(new Event('beforeunload'))
        })
    }

    private unloadHandler(event) {
        event.preventDefault();
        event.returnValue = '';
    }

    /**
     * @description 设置浏览器页面窗口卸载监听
     */
    public setListening(): void {
        window.addEventListener("beforeunload", this.unloadHandler);
    }

    /**
     * 取消卸载监听
     */
    public removeListening(): void {
        window.removeEventListener("beforeunload", this.unloadHandler);
    }
}